import { Turnstile, TurnstileInstance } from "@marsidev/react-turnstile";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { getLang } from "../../plugins/utils";
import styles from "./style.module.scss";

type CloudFlareAuthType = {
  theme?: "auto" | "light" | "dark" | undefined;
  style?: React.CSSProperties;
  loginFailTime?: number | null;
  setCloudflareToken: (value: string) => void;
};
const CloudflareAuth: React.FC<CloudFlareAuthType> = ({
  theme,
  style,
  loginFailTime = null,
  setCloudflareToken,
}) => {
  const { t } = useTranslation();
  const turnstileRef = useRef<TurnstileInstance | null>(null);

  useEffect(() => {
    switch (loginFailTime) {
      case 0:
        return;
      case 1:
        return;
      default:
        setCloudflareToken("");
        turnstileRef?.current?.reset();
        return;
    }
  }, [loginFailTime, setCloudflareToken]);

  return (
    <div>
      <Turnstile
        className={styles.cloudflare}
        ref={turnstileRef}
        siteKey={process.env.REACT_APP_LOGIN_CLOUDFLARE_KEY || ""}
        onSuccess={setCloudflareToken}
        onError={() =>
          setTimeout(() => {
            turnstileRef?.current?.reset();
          }, 30000)
        }
        onExpire={() => {
          turnstileRef?.current?.reset();
        }}
        options={{
          language: getLang(),
          retry: "never",
          theme: theme,
        }}
        scriptOptions={{ async: false, defer: false }}
        style={{ width: "100%", ...style }}
      />
    </div>
  );
};

export default CloudflareAuth;
